/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Notifications_Source_SecurityInputs */

const en_notifications_source_security = /** @type {(inputs: Notifications_Source_SecurityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Security`)
};

const pt_br2_notifications_source_security = /** @type {(inputs: Notifications_Source_SecurityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Segurança`)
};

/**
* | output |
* | --- |
* | "Security" |
*
* @param {Notifications_Source_SecurityInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const notifications_source_security = /** @type {((inputs?: Notifications_Source_SecurityInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Notifications_Source_SecurityInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_notifications_source_security(inputs)
	return pt_br2_notifications_source_security(inputs)
});